<template>
  <div class="container">
    <el-form :model="form" size="mini" inline ref="form">
      <el-form-item label="活动ID" prop="activity_id">
        <el-input v-model="form.activity_id" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="活动名称" prop="activity_name">
        <el-input v-model="form.activity_name" placeholder="请输入"></el-input>
      </el-form-item>
      <!--      <el-form-item label="活动店铺" prop="shop_id">-->
      <!--        <el-select v-model="form.shop_id" filterable remote clearable placeholder="请选择">-->
      <!--          <el-option v-for="item in shops" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->
      <el-form-item label="活动时间" prop="time">
        <el-date-picker
            v-model="form.time"
            type="daterange"
            clearable
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData(form.page=1)">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="data" v-loading="loading" border style="width: 100%">
      <el-table-column label="活动ID" prop="activity_id" width="100"></el-table-column>
      <el-table-column label="活动名称" prop="activity_name" width="160" show-overflow-tooltip></el-table-column>
<!--      <el-table-column label="活动店铺" prop="shop_name" width="160"></el-table-column>-->
      <el-table-column label="活动时间" prop="begin_time" width="270">
        <template slot-scope="{row}">
          <div>{{ row.begin_time }} 至 {{ row.end_time }}</div>
        </template>
      </el-table-column>
      <el-table-column label="评价时间" prop="created_at" width="160"></el-table-column>
      <el-table-column label="用户名" prop="nickname" width="120"></el-table-column>
      <el-table-column label="手机号" prop="mp" width="120"></el-table-column>
      <el-table-column label="用户评分" prop="score" width="120"></el-table-column>
      <el-table-column label="评价内容" prop="comment" width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" min-width="120" fixed="right">
        <template slot-scope="{row}">
          <el-link type="primary" :underline="false" @click="view(row)">查看详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-size="form.pageSize"
        :page-sizes="pageSizes"
        prev-text="上一页"
        next-text="下一页"
        layout="prev, next">
    </el-pagination>
    <comment-detail ref="commentDetailRef"/>
  </div>
</template>

<script>
import commentDetail from "./components/commentDetail.vue";

export default {
  name: "commentList",
  components: {commentDetail},
  data() {
    return {
      loading: false,
      data: [],
      form: {
        page: 1,
        pageSize: 20,
        activity_id: '',
        // shop_id: undefined,
        activity_name: '',
        begin_time: '',
        end_time: '',
        time: [],
        school_id: this.$store.getters.schoolId,
      },
      pageSizes: [10, 20, 30, 40, 50],
      shops: [],
    }
  },
  created() {
    this.loadData(true);
    // try {
    //   this.shops = JSON.parse(localStorage.getItem('shops'));
    // } catch (e) {
    //   this.shops = [];
    // }
  },
  methods: {
    loadData(reload = false) {
      if (this.loading) return;
      if (reload) {
        this.form.page = 1;
      }
      this.loading = true;
      this.$api.get_glue(this.$apiUrl.commentList, {
        ...this.form,
        begin_time: this.form.time && this.form.time[0] ? this.form.time[0] : '',
        end_time: this.form.time && this.form.time[1] ? this.form.time[1] : '',
        time: undefined
      }, (res) => {
        this.loading = false;
        if (res.data) {
          this.data = res.data.list || [];
        } else {
          this.data = [];
        }
      }, (res) => {
        this.loading = false;
        this.data = [];
      });
    },
    reset() {
      this.$refs.form.resetFields();
    },
    view(row) {
      this.$refs.commentDetailRef.open(row);
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.loadData();
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// comment.vue?42e8ee58